import type { MeasurementGuide as Guide } from '@st/contract';
import { useTranslation } from '../../i18n/I18nProvider';

/** Uputa iz `onboarding.measurement-guide`, po ključu koraka (`waist`, `chest`…). */
export function guideStepText(guide: Guide | undefined, key: string, locale: 'hr' | 'en'): string | undefined {
  const step = guide?.steps.find((s) => s.key === key);
  if (!step) return undefined;
  return locale === 'en' ? step.en : step.hr;
}

/**
 * Uputa za mjerenje. Ako trener snimi video, prikazuje se video; dok ga nema,
 * vrijede pisani koraci — ekran nikad ne ostaje prazan.
 */
export function MeasurementGuide({ guide }: { guide: Guide }) {
  const { t, locale } = useTranslation();

  return (
    <section className="rounded-xl border border-line-subtle bg-bg-alt p-4">
      <h3 className="font-display text-[16px] font-semibold text-ink">{t('progress.guide')}</h3>
      <p className="mt-1 text-[12.5px] text-ink-muted">{t('progress.guideHelp')}</p>

      {guide.videoUrl ? (
        <video
          data-testid="measurement-video"
          className="mt-3 w-full rounded-md"
          src={guide.videoUrl}
          controls
          preload="none"
          aria-label={t('progress.guideVideo')}
        />
      ) : guide.steps.length > 0 ? (
        <ol
          data-testid="measurement-steps"
          className="mt-3 flex list-decimal flex-col gap-1.5 pl-5 text-[13px] leading-relaxed text-ink-muted"
        >
          {guide.steps.map((step) => (
            <li key={step.key}>{locale === 'en' ? step.en : step.hr}</li>
          ))}
        </ol>
      ) : (
        <p className="mt-3 text-[13px] text-ink-muted">{t('progress.guideNoVideo')}</p>
      )}
    </section>
  );
}
